//Décalage du scroll
var anchorLink = $(window.location.hash);
		
if ( anchorLink.length ) {

    $("html, body").animate({scrollTop: anchorLink.offset().top - 140 }, 200);
}

function scrollToAnchor(hash) {
var target = $(hash),
    headerHeight = 130; 

if(target.parents('.scroll-in-view').hasClass('scroll-in-view--slide-y')) {
    if(target.parents('.scroll-in-view').hasClass('scroll-in-view-anim-ended')) {
        headerHeight = 130;
    } else {
        headerHeight = 260;
    }
}

if (target.length)
{
    //console.log(target.offset().top, headerHeight, target.offset().top - headerHeight);
    $('html,body').animate({
        scrollTop: target.offset().top - headerHeight
    }, 500);
    
    return false;
}
}

$(window).on('fonts:ready', function() {
    //console.log('fonts:ready');
    if(window.location.hash) {
        scrollToAnchor(window.location.hash);
    }
});

$("a[href*=\\#]:not([href=\\#])").click(function(){
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname)
    {
        scrollToAnchor(this.hash);
    }
});